import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/layout/Layout";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MissionPage from "./pages/MissionPage";
import MembershipPage from "./pages/MembershipPage";
import ProgramsPage from "./pages/ProgramsPage";
import RecruitmentPage from "./pages/RecruitmentPage";
import DevelopmentPage from "./pages/DevelopmentPage";
import RetentionPage from "./pages/RetentionPage";
import AdvancementPage from "./pages/AdvancementPage";
import ConferencePage from "./pages/ConferencePage";
import ConferenceRegisterPage from "./pages/ConferenceRegisterPage";
import ContactPage from "./pages/ContactPage";
import JoinPage from "./pages/JoinPage";
import AdminPage from "./pages/AdminPage";
import ConferenceAdminPage from "./pages/ConferenceAdminPage";
import EventsPage from "./pages/EventsPage";
import MemberLoginPage from "./pages/MemberLoginPage";
import MemberDashboardPage from "./pages/MemberDashboardPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Member pages without layout header/footer */}
          <Route path="/member-login" element={<MemberLoginPage />} />
          <Route path="/member-dashboard" element={<MemberDashboardPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Main pages with layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/mission" element={<Layout><MissionPage /></Layout>} />
          <Route path="/membership" element={<Layout><MembershipPage /></Layout>} />
          <Route path="/programs" element={<Layout><ProgramsPage /></Layout>} />
          <Route path="/recruitment" element={<Layout><RecruitmentPage /></Layout>} />
          <Route path="/development" element={<Layout><DevelopmentPage /></Layout>} />
          <Route path="/retention" element={<Layout><RetentionPage /></Layout>} />
          <Route path="/advancement" element={<Layout><AdvancementPage /></Layout>} />
          <Route path="/conference" element={<Layout><ConferencePage /></Layout>} />
          <Route path="/conference/register" element={<Layout><ConferenceRegisterPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/join" element={<Layout><JoinPage /></Layout>} />
          <Route path="/events" element={<Layout><EventsPage /></Layout>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/conference-admin" element={<ConferenceAdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
